module.exports = __webpack_public_path__ + "static/media/no-asnwers.72bf5129.svg";